import { render } from "./SidebarOrdersLink.vue?vue&type=template&id=0bf37040"
import script from "./SidebarOrdersLink.vue?vue&type=script&lang=js"
export * from "./SidebarOrdersLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__